export default __webpack_public_path__ + "static/media/Ellipse 22 (3).279fd279.png";